// extracted by mini-css-extract-plugin
module.exports = {"link":"xQ_iF","image":"_1Fe8-","root":"XUUsC"};